import { createContext, useContext, useState, useEffect } from 'react';
import { fetchAboutPageData } from './pageDataService';

const AboutDataContext = createContext(null);

export const AboutDataProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    try {
      const cached = localStorage.getItem('bento_about_data');
      return cached ? JSON.parse(cached) : null;
    } catch (e) {
      return null;
    }
  });
  
  const [isLoading, setIsLoading] = useState(!data);

  useEffect(() => {
    let isMounted = true;

    fetchAboutPageData().then((result) => {
      if (isMounted && result) {
        setData(result);
        setIsLoading(false);
        try {
          localStorage.setItem('bento_about_data', JSON.stringify(result));
        } catch (e) {
          console.error("Failed to cache about data", e);
        }
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <AboutDataContext.Provider value={{ data, isLoading }}>
      {children}
    </AboutDataContext.Provider>
  );
};

export const useAboutData = () => {
  const context = useContext(AboutDataContext);
  if (!context) {
    return { data: null, isLoading: true };
  }
  return context;
};
